var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.dataList },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                type
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        label: label,
                        type: type,
                        "min-width": width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        fixed: fixed,
                        align: align,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                slot === "status"
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("div", [_vm._v("状态")]),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                "[开通状态和同步状态]与物流发货状态无关",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                              staticStyle: {
                                                "font-size": "18px",
                                                "margin-top": "3px",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                slot === "orderId"
                                  ? _c("div", [_vm._v("订单编号")])
                                  : _vm._e(),
                                slot === "goodsInfo"
                                  ? _c("div", [
                                      _vm._v("商品信息"),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "280px",
                                          },
                                        },
                                        [_vm._v("单价/数量")]
                                      ),
                                    ])
                                  : _vm._e(),
                                slot === "orderAmount"
                                  ? _c("div", [_vm._v("应付")])
                                  : _vm._e(),
                                slot === "orderTypeLabel"
                                  ? _c("div", [_vm._v("订单类型")])
                                  : _vm._e(),
                                slot === "userInfo"
                                  ? _c("div", [_vm._v("收货人信息")])
                                  : _vm._e(),
                                slot === "ebillFlag"
                                  ? _c("div", [_vm._v("是否电子面单")])
                                  : _vm._e(),
                                slot === "orderStatusLabel"
                                  ? _c("div", [_vm._v("订单状态")])
                                  : _vm._e(),
                                slot === "decryptFlag"
                                  ? _c("div", [_vm._v("解密状态")])
                                  : _vm._e(),
                                slot === "remark"
                                  ? _c("div", [_vm._v("备注")])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "orderId"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "itemN",
                                          style: { zIndex: 100 - scope.$index },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                width: "98%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 下单时间：" +
                                                          _vm._s(
                                                            scope.row
                                                              .createTime ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 支付时间：" +
                                                          _vm._s(
                                                            scope.row.payTime ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 支付方式：" +
                                                          _vm._s(
                                                            scope.row
                                                              .payTypeLabel ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 发货时间：" +
                                                          _vm._s(
                                                            scope.row
                                                              .shipTime || "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 订单来源：" +
                                                          _vm._s(
                                                            scope.row
                                                              .bTypeLabel ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 店铺来源：" +
                                                          _vm._s(
                                                            scope.row
                                                              .shopName || "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" " + _vm._s(scope.row.orderId)),
                                      _c("img", {
                                        staticStyle: {
                                          width: "16px",
                                          height: "16px",
                                          "padding-top": "12px",
                                          "margin-left": "4px",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          src: require("../../../assets/icon_fuzhi.png"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copy(scope.row.orderId)
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                                slot === "goodsInfo"
                                  ? _vm._l(
                                      scope.row.orderDetailList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              display: "flex",
                                              "margin-bottom": "12px",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "88px",
                                                  height: "66px",
                                                },
                                                attrs: { src: item.productPic },
                                              }),
                                            ]),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "8px",
                                                  width: "210px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "left",
                                                      "max-height": "44px",
                                                      "line-height": "22px",
                                                      overflow: "hidden",
                                                      "text-overflow":
                                                        "ellipsis",
                                                      "word-break": "break-all",
                                                      display: "-webkit-box",
                                                      "-webkit-box-orient":
                                                        "vertical",
                                                      "-webkit-line-clamp": "2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.productName)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "left",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(item.spec))]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "30px",
                                                  width: "180px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "center",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "￥" +
                                                        _vm._s(
                                                          item.originAmount
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "center",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "x" + _vm._s(item.itemNum)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "orderAmount"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          "￥" + _vm._s(scope.row.orderAmount)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "orderTypeLabel"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderTypeLabel)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "userInfo"
                                  ? [
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.postName || "--"
                                                )
                                              ),
                                            ]),
                                            scope.row.decryptFlag == false &&
                                            (scope.row.orderStatus == 105 ||
                                              scope.row.orderStatus == 2 ||
                                              scope.row.orderStatus == 3 ||
                                              scope.row.orderStatus == 101 ||
                                              scope.row.orderStatus == 103)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "jiemi",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toJ(
                                                          scope.row.orderId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("解密")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(scope.row.postPhone || "--")
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.postDistrictAddress ||
                                                "--"
                                            ) +
                                              _vm._s(
                                                scope.row.postAddress || "--"
                                              )
                                          ),
                                          _c("img", {
                                            staticStyle: {
                                              width: "16px",
                                              height: "16px",
                                              "margin-left": "8px",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              src: require("../../../assets/icon_fuzhi.png"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyAddress(
                                                  scope.row.postName,
                                                  scope.row.postPhone,
                                                  scope.row.postDistrictAddress,
                                                  scope.row.postAddress
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "ebillFlag"
                                  ? [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "150px" },
                                          attrs: {
                                            placeholder: "请选择",
                                            size: "mini",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.updateEbillFlag(
                                                $event,
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.ebillFlag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "ebillFlag",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.ebillFlag",
                                          },
                                        },
                                        _vm._l(_vm.options, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "decryptFlag"
                                  ? [
                                      scope.row.decryptFlag == false
                                        ? _c("p", [_vm._v(" 未解密 ")])
                                        : _c("p", [_vm._v(" 已解密 ")]),
                                    ]
                                  : _vm._e(),
                                slot === "orderStatusLabel"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.statusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "danger-bg":
                                                  scope.row.orderStatus == 99,
                                              },
                                              {
                                                "warning-bg":
                                                  scope.row.orderStatus < 4,
                                              },
                                              "round",
                                              {
                                                "success-bg":
                                                  scope.row.orderStatus === 6,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.orderStatusLabel
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "remark"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.decryptErrorMsg || "--"
                                          )
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        align: align,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApply,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApply = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [_vm._v("是否审核通过？")]),
            _c(
              "div",
              { staticStyle: { "margin-top": "18px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.radio,
                      callback: function ($$v) {
                        _vm.radio = $$v
                      },
                      expression: "radio",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 3 } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: 6 } }, [_vm._v("驳回")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.radio == 3
              ? _c("div", { staticClass: "pass" }, [
                  _vm._v(" 确认后，金额"),
                  _c("span", { staticClass: "price" }, [_vm._v("￥1000.00")]),
                  _vm._v("将退回买家账户 "),
                ])
              : _vm._e(),
            _vm.radio == 6
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "24px",
                      width: "90%",
                      "margin-bottom": "24px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px", width: "10%" },
                        },
                        [_vm._v("备注")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "90%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              maxlength: "200",
                              "show-word-limit": "",
                              rows: "5",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }